import { AmenitySvg, AmenitySvgProps } from "./AmenitySvg";

export function CoolingSystemIcon(props: AmenitySvgProps) {
  return (
    <AmenitySvg {...props}>
      <path
        d="M19 6C21.3389 6 22.5083 6 23.3621 6.53647C23.8073 6.81621 24.1838 7.19267 24.4635 7.63789C25 8.49167 25 9.66111 25 12C25 14.3389 25 15.5083 24.4635 16.3621C24.1838 16.8073 23.8073 17.1838 23.3621 17.4635C22.5083 18 21.3389 18 19 18L11 18C8.66111 18 7.49167 18 6.63789 17.4635C6.19267 17.1838 5.81621 16.8073 5.53647 16.3621C5 15.5083 5 14.3389 5 12C5 9.66111 5 8.49167 5.53647 7.63789C5.81621 7.19267 6.19267 6.81621 6.63789 6.53647C7.49167 6 8.66111 6 11 6L19 6Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M10 15H20"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M21 10H21.009"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.8 21C9.8 21 10.6 22.875 9 24"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2 21C20.2 21 19.4 22.875 21 24"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 21V24"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </AmenitySvg>
  );
}
